import { dateTime, defineAction, number, object } from '~/prix'
import expiredAttendanceCancellationAction from './expiredAttendanceCancellation.action.json'

const expiredAttendanceCancellationDefinition = defineAction({
  ...expiredAttendanceCancellationAction,
  userActivityLog: true,
  input: object({}),
  output: object({
    canceledCount: number(),
    canceledAt: dateTime(),
    expirationThreshold: dateTime(),
  }),
})

export default expiredAttendanceCancellationDefinition
